import { sanitiseHtmlContent } from './widgetUtilities';

export interface HpHtmlWidgetProps {
  className?: string;
  html: string;
  tagName?: 'p' | 'sub' | 'span' | 'li' | 'h3';
}

/**
 * Used to render HTML created from generated markdown.
 * @param props The default tagName is *div*.
 *
 * Beware that if your HTML is of the form:
 *
 *    `<p>...</p>`
 *
 * (which is quite likely) and you specify *tagName* `p`, then your rendered HTML will be:
 *
 *   `<div><p>...</p></div>`
 *
 * which is equivalent to not specifying 'tagName'.
 * @returns A JSX element or null.
 */
export function HtmlWidget({ className, html, tagName }: HpHtmlWidgetProps): JSX.Element | null {
  if (!html) {
    return null;
  }

  if (tagName === 'p' && html.startsWith('<p>')) {
    tagName = undefined; // use 'div'.
  }

  const sanitisedHtml = sanitiseHtmlContent(html);
  const attribs = { className, dangerouslySetInnerHTML: { __html: sanitisedHtml } };

  if (tagName) {
    if (tagName === 'p') {
      return <p {...attribs} />;
    } else if (tagName === 'li') {
      return <li {...attribs} />;
    } else if (tagName === 'sub') {
      return <sub {...attribs} />;
    } else if (tagName === 'span') {
      return <span {...attribs} />;
    } else if (tagName === 'h3') {
      return <h3 {...attribs} />;
    }
  }

  return <div {...attribs} />;
}
